import LoadingLogo from '@components/Loading/LoadingLogo';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { Modal, ModalID } from '@repo/ui/src/modules/UI';

const CheckoutLoader = () => {
  const { t } = useTranslation();
  return (
    <Modal
      id={ModalID.checkoutLoader}
      aria-label="loading screen"
      fullScreen
      noButcherPaper
      disableClose
      className="bg-white"
    >
      <div className="flex flex-col justify-center align-center h-full w-full">
        <div className="max-h-40">
          <LoadingLogo />
        </div>
        <h5 className="tra-text-web-heading-6 text-center pt-5 text-neutral-400">
          {t('cart.continueToCheckout', undefined, { default: 'Taking you to Checkout' })}
        </h5>
        <button
          className="tra-text-web-body-s max-w-xs text-center mx-auto py-5"
          onClick={() => window.location.reload()}
        >
          {t('cart.loadingButtonText', undefined, {
            default: 'If you are not redirected please click here',
          })}
        </button>
      </div>
    </Modal>
  );
};

export default CheckoutLoader;
